import { CSSProperties } from "react";
import FontWeight from "../../../../../../../models/constants/FontWeight";

export default class DialogAddressPickerViewStyle {

    addressInput: React.CSSProperties =
    {
        position: 'relative', 
        width:'100%',
        fontWeight:300
    }

    label : CSSProperties = {
        fontWeight : FontWeight.LIGHT
    }
}